import React, { useState } from 'react';
import { Card, Button } from './ui';
import { ShieldCheck, Plus, Minus, Scale, Clock, Lock, Zap, FileText } from 'lucide-react';
const CHECKOUT_URL = 'https://frezzer-lleno.impultienda.ar/checkout';
export function Guarantee() {
  return <section className="py-10 px-4" data-id="element-191" data-mp="31lkdd7y2nf2q">
      <div className="max-w-3xl mx-auto" data-id="element-192" data-mp="2wlfzzqsgn0gq">
        <Card className="bg-gradient-to-br from-slate-900 to-slate-800 border-emerald-500/30 text-center relative overflow-hidden" data-id="element-193" data-mp="2wmr1tl2chy57">
          <div className="absolute -right-10 -top-10 text-emerald-500/10" data-id="element-194" data-mp="3p9k6ufmrpjl0">
            <ShieldCheck className="w-64 h-64" data-id="element-195" data-mp="3pbo80pta84hl" />
          </div>
          <div className="relative z-10" data-id="element-196" data-mp="3khai32xe2pkb">
            <ShieldCheck className="w-16 h-16 text-emerald-400 mx-auto mb-6" data-id="element-197" data-mp="3fjih7jernt3z" />
            <h2 className="text-3xl font-bold text-white mb-6" data-id="element-198" data-mp="3fhefn84cb66v">
              GARANTÍA DE 7 DÍAS
            </h2>
            <p className="text-xl text-slate-300 mb-6" data-id="element-199" data-mp="gvbm1tqhlx3e">
              Queremos que puedas conocer el material con tranquilidad.
            </p>
            <p className="text-lg text-slate-400 mb-8" data-id="element-200" data-mp="2hke4fdqk9and">
              Accedé al Kit y explorá sus recursos.
              <br data-id="element-201" data-mp="2ljmxegds14hv" />
              Si dentro del período de garantía decidís que
              <br data-id="element-202" data-mp="27ubejmeqkct9" />
              <strong className="text-white" data-id="element-203" data-mp="27sqhnq4y8hs8">no es para vos</strong>, podés
              solicitar el reembolso
              <br data-id="element-204" data-mp="2cr1tg6et12d3" />
              según las condiciones de compra.
            </p>
            <p className="text-sm text-emerald-400/80 font-medium" data-id="element-205" data-mp="1xuau1x54rqnh">
              Pago único · 100% digital · Acceso inmediato.
            </p>
          </div>
        </Card>
      </div>
    </section>;
}
export function FAQ() {
  const faqs = [{
    q: '¿Tengo que leer los 3 tomos antes de empezar?',
    a: 'No. El Kit está organizado para que puedas avanzar progresivamente y consultar las secciones y herramientas que más necesitás.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Después de completar tu compra recibís acceso digital al Kit.'
  }, {
    q: '¿Es un producto físico?',
    a: 'No. El Kit de Conducta Infantil es 100% digital.'
  }, {
    q: '¿Puedo consultarlo desde el celular?',
    a: 'Sí. Podés acceder al material desde dispositivos compatibles y consultarlo cuando lo necesites.'
  }, {
    q: '¿Qué pasa si nuestro principal problema son las rabietas?',
    a: 'El Tomo 2 está enfocado especialmente en límites, rabietas y emociones y se complementa con las herramientas prácticas del Kit.'
  }, {
    q: '¿Y si lo que más nos cuesta son las rutinas?',
    a: 'El Tomo 3 trabaja específicamente rutinas y planificación de conducta y se complementa con el Pack de Rutinas Visuales.'
  }, {
    q: '¿Incluye herramientas prácticas?',
    a: 'Sí. Además de los 3 tomos recibís los 5 bonos incluidos.'
  }, {
    q: '¿Reemplaza el acompañamiento profesional?',
    a: 'No. Es un recurso educativo para madres, padres y cuidadores y no sustituye evaluación, diagnóstico o acompañamiento profesional cuando sea necesario.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí. La compra cuenta con una garantía de 7 días según las condiciones indicadas.'
  }];
  const [open, setOpen] = useState<number | null>(0);
  return <section className="py-12 px-4 bg-slate-900/30 pt-[4px] pb-[4px]" data-id="element-206" data-mp="14n62gwzx89kb">
      <div className="max-w-3xl mx-auto" data-id="element-207" data-mp="19lhcp8u4om32">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center mb-8 flex items-center justify-center gap-3" data-id="element-208" data-mp="1dlriake0dahe">
          <span className="text-brand-400" data-id="element-209" data-mp="1ijt071zp73ra">❓</span> PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-210" data-mp="1nark0bjwajza">
          {faqs.map((faq, i) => <div key={i} className="border border-slate-800 rounded-xl bg-slate-900 overflow-hidden" data-id="element-211" data-mp="1ndnjw5faziqd" data-mpi={i}>
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpen(open === i ? null : i)} data-id="element-212" data-mp="1xaifafga530f">
                <span className="font-bold text-white pr-8" data-id="element-213" data-mp="2yynqp1fj5xf8">{faq.q}</span>
                {open === i ? <Minus className="w-5 h-5 text-brand-400 shrink-0" data-id="element-214" data-mp="2u0ci0u0z1syl" /> : <Plus className="w-5 h-5 text-slate-500 shrink-0" data-id="element-215" data-mp="37qz67s93w0gf" />}
              </button>
              {open === i && <div className="px-6 pb-4 text-slate-400" data-id="element-216" data-mp="33t1hsrn5tie3">{faq.a}</div>}
            </div>)}
        </div>
      </div>
    </section>;
}
export function CostOfInaction() {
  return <section className="py-12 px-4" data-id="element-217" data-mp="2p1rf2muc4v6g">
      <div className="max-w-4xl mx-auto" data-id="element-218" data-mp="2p2u56sju2tlb">
        <div className="text-center mb-8" data-id="element-219" data-mp="2ozogvfj13vqn">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 flex items-center justify-center gap-3" data-id="element-220" data-mp="2k2eu67n0xy6i">
            <Scale className="w-9 h-9 text-amber-400" data-id="element-221" data-mp="4ainuub3jih9" /> ¿CUÁNTO CUESTA SEGUIR
            IMPROVISANDO?
          </h2>
        </div>

        <div className="overflow-x-auto mb-10" data-id="element-222" data-mp="3vhl975496ujk">
          <table className="w-full text-left border-collapse bg-slate-900 rounded-xl overflow-hidden" data-id="element-223" data-mp="7sy4ngv7te73">
            <thead data-id="element-224" data-mp="bvbas6dvje4e">
              <tr className="border-b border-slate-800 bg-slate-800/50" data-id="element-225" data-mp="bvui6t5wek46">
                <th className="p-4 text-slate-300 font-medium" data-id="element-226" data-mp="3u1haoa4aacq0">Sin un sistema</th>
                <th className="p-4 text-red-400 font-bold" data-id="element-227" data-mp="2u4qrnc0nl6e">Costo cotidiano</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800" data-id="element-228" data-mp="qjpc2cvn6uiu">
              <tr data-id="element-229" data-mp="qmbiuaapl600">
                <td className="p-4 text-slate-400" data-id="element-230" data-mp="visju530beui">
                  Repetir la misma instrucción una y otra vez
                </td>
                <td className="p-4 text-white font-medium" data-id="element-231" data-mp="gt4duqjvrs0g">
                  Frustración para ambos
                </td>
              </tr>
              <tr data-id="element-232" data-mp="lr61zpw5yhis">
                <td className="p-4 text-slate-400" data-id="element-233" data-mp="19j3b3988avg7">
                  Improvisar frente a una rabieta
                </td>
                <td className="p-4 text-white font-medium" data-id="element-234" data-mp="1e9te4ft6mm7q">
                  No saber qué hacer cuando más necesitás claridad
                </td>
              </tr>
              <tr data-id="element-235" data-mp="1j6fncp7p5zjh">
                <td className="p-4 text-slate-400" data-id="element-236" data-mp="1j5xij46yyczy">Rutinas sin estructura</td>
                <td className="p-4 text-white font-medium" data-id="element-237" data-mp="1e7cfyy48vh8c">
                  Discusiones que vuelven a repetirse
                </td>
              </tr>
              <tr data-id="element-238" data-mp="1a4zckgcyzveq">
                <td className="p-4 text-slate-400" data-id="element-239" data-mp="1a5hiy5tcjq0d">Límites inconsistentes</td>
                <td className="p-4 text-white font-medium" data-id="element-240" data-mp="157fx5d4jdcl7">
                  Menos claridad para todos
                </td>
              </tr>
              <tr data-id="element-241" data-mp="10e4r3e7jszuc">
                <td className="p-4 text-slate-400" data-id="element-242" data-mp="vgbjqhuidzsh">Perder la paciencia</td>
                <td className="p-4 text-white font-medium" data-id="element-243" data-mp="vei8sqcv4teo">
                  Culpa después del conflicto
                </td>
              </tr>
              <tr data-id="element-244" data-mp="mf4yxwktu2tf">
                <td className="p-4 text-slate-400" data-id="element-245" data-mp="mfn5bm17dxf2">
                  Cada adulto respondiendo de manera diferente
                </td>
                <td className="p-4 text-white font-medium" data-id="element-246" data-mp="2t4fdqlzgkfo4">
                  Menos consistencia
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="text-center max-w-2xl mx-auto mb-10" data-id="element-247" data-mp="2y5mkqits1atq">
          <h3 className="text-2xl font-bold text-brand-400 mb-4" data-id="element-248" data-mp="326evjgiarns4">
            Mañana van a volver a aparecer: “Guardá los juguetes.” “Apagá la
            tablet.” “Vamos a bañarnos.” “Es hora de dormir.” La diferencia es
            que podés llegar a esos momentos con nuevas herramientas.
          </h3>
          <blockquote className="text-xl text-slate-300 italic border-l-4 border-brand-500 pl-6 py-2 text-left" data-id="element-249" data-mp="2egc3v1iaoju1">
            "No se trata de tener hijos perfectos. Se trata de tener más
            claridad para saber cómo actuar cuando aparecen los momentos
            difíciles."
          </blockquote>
        </div>

        {/* Final CTA Block */}
        <Card glow className="bg-slate-900 border-brand-500/50 text-center" data-id="element-250" data-mp="1vorq35mtmg0o">
          <div className="inline-flex items-center gap-2 bg-red-500/10 text-red-400 border border-red-500/20 px-4 py-2 rounded-full font-bold mb-8" data-id="element-251" data-mp="1vmor3w3oxcjt">
            <Clock className="w-5 h-5" data-id="element-252" data-mp="k3nvqctilz7u" />
            EL PRECIO CIERRA EN: 23 hs : 59 min : 52 seg
          </div>

          <div className="grid md:grid-cols-1 gap-6 mb-8 max-w-md mx-auto" data-id="element-253" data-mp="y36pu1phra15">
            <div className="p-6 border border-slate-700 rounded-xl bg-slate-800/50" data-id="element-254" data-mp="u0k48ijeylce">
              <h4 className="font-bold text-white mb-2" data-id="element-255" data-mp="1801msg6492db">
                🧩 KIT DE CONDUCTA INFANTIL
              </h4>
              <p className="text-sm text-slate-400 mb-4" data-id="element-256" data-mp="130gpea6lh22p">
                3 Tomos + 5 Bonos · Pago único
              </p>
              <div className="flex items-baseline justify-center gap-2 mb-6" data-id="element-257" data-mp="1hpv0pntqdtkq">
                <span className="text-slate-500 line-through text-sm" data-id="element-258" data-mp="1csco9ngi8w7z">
                  49.99
                </span>
                <span className="text-3xl font-black text-white" data-id="element-259" data-mp="1qrm0yd5i5877">19.99</span>
                <span className="text-sm text-slate-400" data-id="element-260" data-mp="1lt10ccmc8mi8">USD</span>
              </div>
              <Button className="w-full" variant="outline" onClick={() => {
              window.location.href = CHECKOUT_URL;
            }} data-id="element-261" data-mp="25di2a2ev2472">
                → QUIERO MI KIT DE CONDUCTA INFANTIL
              </Button>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-400" data-id="element-262" data-mp="20ddio3inotcm">
            <span className="flex items-center" data-id="element-263" data-mp="1mm8rzqx9nbef">
              <Lock className="w-4 h-4 mr-1 text-slate-300" data-id="element-264" data-mp="1mlgu29g751kz" /> Pago seguro
            </span>
            <span className="flex items-center" data-id="element-265" data-mp="1rg39cnpefeac">
              <Zap className="w-4 h-4 mr-1 text-amber-400" data-id="element-266" data-mp="1cpvqw7ze5v9n" /> Acceso inmediato
            </span>
            <span className="flex items-center" data-id="element-267" data-mp="1hnffa0pszofb">
              <ShieldCheck className="w-4 h-4 mr-1 text-emerald-400" data-id="element-268" data-mp="1hm4ca346mkp9" /> Garantía
              7 días
            </span>
            <span className="flex items-center" data-id="element-269" data-mp="18nisy5qvz1nf">
              <FileText className="w-4 h-4 mr-1 text-blue-400" data-id="element-270" data-mp="18m7i5lz0wtmt" /> 100% digital
            </span>
          </div>
        </Card>
      </div>
    </section>;
}
export function Footer() {
  return <footer className="bg-slate-950 py-10 px-4 border-t border-slate-900" data-id="element-271" data-mp="399w1ym0wx0gv">
      <div className="max-w-4xl mx-auto text-center" data-id="element-272" data-mp="2v9v47ffy295m">
        <div className="inline-flex items-center gap-2 mb-6" data-id="element-273" data-mp="2vbejp3ts0g6c">
          <span className="text-2xl" data-id="element-274" data-mp="309g3jqz10jiv">🧩</span>
          <span className="text-brand-400 font-bold tracking-widest uppercase" data-id="element-275" data-mp="30a99wqu2p70h">
            PUNTO DIGITAL™
          </span>
        </div>

        <p className="text-slate-400 mb-4 max-w-2xl mx-auto" data-id="element-276" data-mp="3rzua124pmtki">
          Herramientas prácticas para madres, padres y cuidadores que quieren
          entender mejor la conducta, acompañar emociones, establecer límites y
          construir rutinas con mayor claridad.
        </p>
        <p className="text-slate-500 mb-8 italic" data-id="element-277" data-mp="arqqpr1tcew8">
          Porque criar no viene con un manual... pero eso no significa que
          tengas que improvisar frente a cada momento difícil.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm text-slate-400 mb-12" data-id="element-278" data-mp="owr0lf4kkjhy">
          <a href="mailto:supportpuntodigital@gmail.com" className="hover:text-brand-400 transition-colors" data-id="element-279" data-mp="kucmf8bui7x0">
            📧 supportpuntodigital@gmail.com
          </a>
          <a href="#" className="hover:text-brand-400 transition-colors" data-id="element-280" data-mp="tor0x8ojxef2">
            🌐 www.puntodigital.store
          </a>
        </div>

        <div className="text-xs text-slate-600 space-y-2" data-id="element-281" data-mp="607s8s1lazmg">
          <p data-id="element-282" data-mp="1xux0xkgyk3x">© Punto Digital™ 2026 — Todos los derechos reservados.</p>
          <p data-id="element-283" data-mp="fwu9z7ymdak9">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-900" data-id="element-284" data-mp="aw6hsiynmnog">
          <p className="text-brand-500/50 font-medium italic" data-id="element-285" data-mp="1rb7tk0mcb3uh">
            🧩 "Menos improvisación. Más herramientas para saber cómo actuar."
          </p>
        </div>
      </div>
    </footer>;
}